import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "border-t border-border p-4 space-y-2" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 3,
  class: "text-center text-sm text-muted-foreground py-2"
}

import { useRouter } from 'vue-router';
import { useCartStore } from '@/stores/cartStore';
import { useCheckoutStore } from '@/stores/checkoutStore';
import { useToast } from '@/composables/useToast';


export default /*@__PURE__*/_defineComponent({
  __name: 'CartActions',
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const router = useRouter();
const cartStore = useCartStore();
const checkoutStore = useCheckoutStore();
const { success, error } = useToast();

const emit = __emit;

const handleViewCart = () => {
  emit('close');
  router.push({ name: 'Cart' });
};

const handleProceedToCheckout = async () => {
  try {
    // Sync cart items to checkout store
    checkoutStore.setCheckoutSession({
      cartId: cartStore.cartId || undefined,
      cartItems: cartStore.cartItems,
      isValid: true,
    });

    emit('close');
    router.push({ name: 'Checkout' });
  } catch (err) {
    error('Failed to proceed to checkout');
    console.error('Checkout error:', err);
  }
};

const handleClearCart = async () => {
  if (!confirm('Are you sure you want to clear your cart?')) {
    return;
  }

  try {
    await cartStore.clearCart();
    success('Cart cleared');
  } catch (err) {
    error('Failed to clear cart');
    console.error('Clear cart error:', err);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(cartStore).isEmpty)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          disabled: _unref(cartStore).isLoading,
          class: "w-full btn-outline rounded-lg px-4 py-2 font-semibold transition-colors disabled:opacity-50 disabled:cursor-not-allowed",
          onClick: handleViewCart
        }, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("i", { class: "fas fa-folder-open mr-2" }, null, -1),
          _createTextVNode(" View Cart ", -1)
        ]))], 8, _hoisted_2))
      : _createCommentVNode("", true),
    (!_unref(cartStore).isEmpty)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          disabled: _unref(cartStore).isLoading,
          class: "w-full btn-primary rounded-lg px-4 py-2 font-semibold transition-colors disabled:opacity-50 disabled:cursor-not-allowed",
          onClick: handleProceedToCheckout
        }, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("i", { class: "fas fa-arrow-right mr-2" }, null, -1),
          _createTextVNode(" Proceed to Checkout ", -1)
        ]))], 8, _hoisted_3))
      : _createCommentVNode("", true),
    (!_unref(cartStore).isEmpty)
      ? (_openBlock(), _createElementBlock("button", {
          key: 2,
          disabled: _unref(cartStore).isLoading,
          class: "w-full px-4 py-2 text-destructive border border-destructive/30 rounded-lg font-semibold hover:bg-destructive/10 transition-colors disabled:opacity-50 disabled:cursor-not-allowed",
          onClick: handleClearCart
        }, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("i", { class: "fas fa-trash-alt mr-2" }, null, -1),
          _createTextVNode(" Clear Cart ", -1)
        ]))], 8, _hoisted_4))
      : (_openBlock(), _createElementBlock("p", _hoisted_5, " Start shopping to add items "))
  ]))
}
}

})